import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Phone } from 'lucide-react';
export function CTABanner() {
  return <section className="py-16 bg-[#1f1f1f] px-4 sm:px-6 lg:px-8" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="rounded-[2.5rem] relative overflow-hidden" data-id="element-3">
          {/* Background image */}
          <img src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=1400&q=80" alt="Nevada landscape" className="absolute inset-0 w-full h-full object-cover" data-id="element-4" />
          {/* Yellow overlay */}
          <div className="absolute inset-0 bg-[#FFD700]/90" data-id="element-5" />

          <div className="relative z-10 p-10 md:p-16 flex flex-col md:flex-row items-center justify-between gap-10" data-id="element-6">
            <div className="text-center md:text-left max-w-2xl" data-id="element-7">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#1f1f1f] mb-4 uppercase tracking-tight" data-id="element-8">
                READY TO GET STARTED?
              </h2>
              <p className="text-[#2d2d2d] text-lg md:text-xl font-medium" data-id="element-9">
                Get your free, no-obligation quote today. Our experts are
                standing by to help with your electrical needs.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 w-full md:w-auto shrink-0" data-id="element-10">
              <button className="flex items-center justify-center gap-2 bg-[#1f1f1f] hover:bg-[#2d2d2d] text-white px-8 py-4 rounded-full font-bold text-lg transition-colors" data-id="element-11">
                Get Free Quote
                <ArrowRight className="w-5 h-5 text-[#FFD700]" data-id="element-12" />
              </button>
              <a href="tel:+17025550123" className="flex items-center justify-center gap-2 bg-transparent border-2 border-[#1f1f1f] text-[#1f1f1f] hover:bg-[#1f1f1f]/10 px-8 py-4 rounded-full font-bold text-lg transition-colors" data-id="element-13">
                <Phone className="w-5 h-5" data-id="element-14" />
                Call Now
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}